import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import TrendingVideos from "@/pages/home/components/TrendingVideos";
import Photobooks from "@/pages/home/components/Photobooks";
import Gallery from "@/pages/home/components/Gallery";
import Categories from "@/pages/home/components/Categories";
import Updates from "@/pages/home/components/Updates";
import Guide from "@/pages/home/components/Guide";
import Faq from "@/pages/home/components/Faq";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <TrendingVideos />
        <Photobooks />
        <Gallery />
        <Categories />
        <Updates />
        <Guide />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}